module.exports = __webpack_public_path__ + "img/icona_live_tv_menu.3d84728a.png";